<template>
  <div class="page-content">
    <div class="page-main-content">
      <div class="container-fluid">
        <v-row class="d-flex d-sm-none">
          <v-list width="100%">
            <v-list-item
              two-line
              v-for="(item, index) in data"
              :key="index"
              class="green lighten-5 ma-2 rounded-lg"
              ripple
              :to="`/administrador/locations/${item.id}/edit`"
            >
              <v-list-item-content>
                <v-list-item-title>
                  <div>
                    {{ item.description }}
                  </div>
                </v-list-item-title>
                <v-list-item-subtitle>{{ item.brand_description }}</v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <v-list-item-subtitle class="text-caption">
                  <v-icon>mdi-pencil</v-icon>
                </v-list-item-subtitle>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-row>
        <div class="row">
          <bx-box
            :title="totalLocations + ' ' + $t('lang.admin.list_of_locations')"
            color="white"
            no-padding
            class="col-12"
            :loading="shouldLoading"
          >
            <template v-slot:default>
              <skeleton-table :columns="4" v-if="shouldLoading" />

              <bx-table
                :data="data"
                :columns="columns"
                paginated
                v-if="!shouldLoading"
                :currentPage="page"
                :perPage="itemsPerPage"
                backendPagination
                :total="totalLocations"
                @search="onSearch"
                @update:currentPage="updatePage"
              >
                <template slot-scope="props">
                  <bx-table-column centered>{{ props.row.description }}</bx-table-column>
                  <bx-table-column centered>{{ props.row.brand_description }}</bx-table-column>

                  <!-- Conditionally render the Active Column based on role === 1 -->
                  <bx-table-column centered v-if="role === 1">
                    <v-icon v-if="props.row.active" color="green">mdi-check</v-icon>
                    <v-icon v-else color="red">mdi-close</v-icon>
                  </bx-table-column>

                  <bx-table-column centered>
                    <router-link
                      :to="`/administrador/locations/${props.row.id}/edit`"
                      class="bx-link bx-link-bold"
                      >Edit</router-link
                    >
                  </bx-table-column>
                </template>
              </bx-table>
            </template>
          </bx-box>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AreasList",
  data() {
    return {
      shouldLoading: true,
      columns: [],
      data: [],
      totalLocations: 0,
      itemsPerPage: 20,
      filters: {
        Description: null
      },
      page: 1,
      role: 0  // Assuming you set role from somewhere (props, store, etc.)
    };
  },
  mounted() {
    this.role = this.$store.state.user.role;
    this.filters.description = this.$session.get(this.key + "Description");
    this.getData();
  },
  methods: {
    onSearch(field, value) {
      this.$session.set(this.key + field, value);
      this.filters[field] = value;
      this.getData();
    },
    updatePage(p) {
      this.page = p;
      this.getData();
    },
    async getData() {
      let locations = await this.$api.location.listLocations({
        offset: (this.page - 1) * this.itemsPerPage,
        limit: this.itemsPerPage,
        description__icontains: this.filters.Description
      });
      this.data = locations.results;
      this.totalLocations = locations.count;

      // Only include the active column if role is 1
      this.columns = [
        {
          field: "Description",
          label: this.$t("lang.admin.label_description"),
          centered: true,
          filter: {
              placeholder: this.$t("lang.inventory.stocks.table_field_1"),
              value: this.filters.Description
            }
        },
        {
          field: "brand_description",
          label: this.$t("lang.admin.label_brand"),
          centered: true
        },
        // Conditionally add the 'Active' column only if role is 1
        ...(this.role === 1
          ? [
              {
                field: "active",
                label: this.$t("lang.admin.label_active"),
                centered: true
              }
            ]
          : []),
        {
          field: "",
          label: this.$t("lang.admin.label_action"),
          centered: true
        }
      ];

      this.shouldLoading = false;
    }
  }
};
</script>
